import type { FaireProductEntity } from "../../entity_types/product";

export const p_3zhwkd9knc: FaireProductEntity = {
  token: "p_3zhwkd9knc",
  type: "product",
  name: "Collared Cap Sleeve Wrap Midi Dress",
  brandToken: "b_elccldtdr7",
  brandName: "Urban Daizy",
  imageUrl:
    "https://cdn.faire.com/fastly/2f2714e8097a61b4fbe74e172e718a7908e33e02311c84c84c87ffa66326aa36.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/177f9a7094cf21148601ac41064a08e9ab6d5f49357324322b018e2f610719bf.jpeg",
    "https://cdn.faire.com/fastly/ab7c84ec929eb86fa637206e91db8cb3993502cfc68669e9d119aa5a7394fb7e.jpeg",
    "https://cdn.faire.com/fastly/a33ad9185629832af0593f8af51a644ee0b538f588178c1568095ff5cd88b31f.jpeg",
    "https://cdn.faire.com/fastly/73aab11cfbe9eff46cca7c323f011cf3e3bac8f61214954d3381e715bb7a467a.jpeg",
    "https://cdn.faire.com/fastly/d72eccf6dd6f07db176ee7b6629f85d57a9a55af7ad7873437f331b730bf50be.jpeg",
    "https://cdn.faire.com/fastly/baaec7656e4e2ef71c5aec3d5b39a8caa00e32df6fad4d24d37d1c7b416513b2.jpeg",
    "https://cdn.faire.com/fastly/70ee2133031140079af4ff23e14811894505902de2c48fc91923f916ffadbceb.jpeg",
    "https://cdn.faire.com/fastly/e2f10ebd11d794fdacd8d12def31ff5db9c333bbd45e674b976f824ca8d30467.jpeg",
    "https://cdn.faire.com/fastly/cb66a4be127572dca821a7b0859113974d75f532220c3a18099324fa423807e9.jpeg",
    "https://cdn.faire.com/fastly/4b6a7cb391d936dce5fe00b6aa67cbc00610cbb533ddf700bde4eeb57ae5dcb9.jpeg",
    "https://cdn.faire.com/fastly/c033b0183795e01a92fd18a7155162c8937726b3f625a2e9d5d00bd03d671237.jpeg",
    "https://cdn.faire.com/fastly/7e4d766bb5c8eecdaa74ac26e6b208e2d48ad6990ba9e15b36ade9889adcf3b1.jpeg",
    "https://cdn.faire.com/fastly/ae7b66b56862000f7d3b9dbd619098a4480b1df921bf0ec908d84d9fd25a0605.jpeg",
    "https://cdn.faire.com/fastly/d61cdee55ff1566072d9dee15275b8c620b3c62bfc9827364f9051d1a99ce516.jpeg",
    "https://cdn.faire.com/fastly/e5476ad3c563f2508e2563261e85325f05b3c8aef93db8bd80be47169dcdcb0f.jpeg",
    "https://cdn.faire.com/fastly/46baa7857b74049b4b638d4bc007a5dfc02e7fab8711989fe218ca6f9ee4c562.jpeg",
    "https://cdn.faire.com/fastly/e5110352a7cc52475685712e561e6ecf51b99938f1df6bd0bbd81fa7d83dc89d.jpeg",
    "https://cdn.faire.com/fastly/92a98c1a558ac697c23feda32bf7a910a54f114326ddd67530c1ff02f46e72c4.jpeg",
    "https://cdn.faire.com/fastly/e84bc0f1a0a5ca778e07f95aefc283e49da86f368472f77b2e69820cfdff7107.jpeg",
    "https://cdn.faire.com/fastly/771e2195a8de1b62567c54df88d1817d873c5d1aa5fe47c605122f52fce4e1d1.jpeg",
    "https://cdn.faire.com/fastly/6781ef5db60bbe41e41e9e569f9d318ddce721b8168793e3d49ea094c9de48a4.jpeg",
    "https://cdn.faire.com/fastly/4b64a4d6507e7d8d0c28ce8e8957073abcd5f9a3eda0d32b905c2853bf6f591d.jpeg",
    "https://cdn.faire.com/fastly/b5e80dce521c20c790b0c0facd8053de608e5ebf94478f5e9ded1c00b560ca93.jpeg",
    "https://cdn.faire.com/fastly/dce369dfbe89a14581cd565e12ac37a02e845014926b050b21a62d69c112508c.jpeg",
    "https://cdn.faire.com/fastly/9447e82bbafbd281c4efce7294c3d4b86cfd3176878a690936e09287665969e4.jpeg",
  ],
  priceDollars: 26.99,
  description:
    "Exude timeless elegance with this crisp white midi dress, perfect for garden parties or brunch. The sophisticated design features a classic shirt collar that frames a flattering V-neck wrap front, secured by an adjustable side tie at the waist. Finished with structured cap sleeves and a full, flowy skirt, it offers a polished and feminine silhouette.\n  \n  Material: Self:100% Cotton ,Lining: 100% Polyester\n  \n  Design: Wrap dress with shirt collar and side tie\n  \n  Sleeves: Structured cap sleeves\n  \n  Fit: Midi length with adjustable waist\n  \n  Sizing Pack: 2-2-2 (S-L)\n  \n  Origin: Made in China",
  tags: [],
  msrpDollars: 53.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:49.415Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
